export function formatFileSize(input: number | string | bigint): string {
  const bytes = typeof input === 'bigint' ? input : BigInt(input)
  if (bytes === 0n) return '0 B'
  if (bytes < 0n) throw new RangeError('File size cannot be negative')

  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
  let unit = 0
  let divisor = 1n
  while (unit < sizes.length - 1 && bytes >= divisor * 1024n) {
    divisor *= 1024n
    unit += 1
  }
  if (unit === 0) return `${bytes} B`

  const tenths = (bytes * 10n + divisor / 2n) / divisor
  const whole = tenths / 10n
  const fraction = tenths % 10n
  return `${whole}${fraction === 0n ? '' : `.${fraction}`} ${sizes[unit]}`
}

export function formatDate(dateString: string): string {
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

/**
 * Convert a search result score into a match percentage.
 *
 * The API reports `score` as an ascending distance (0 = best match). Raw
 * vector-only results use dot distance, which can exceed 1, so the similarity
 * is clamped to 0-100.
 */
export function formatMatchPercent(score: number): string {
  if (!Number.isFinite(score)) return '0.0'
  const similarity = Math.min(Math.max(1 - score, 0), 1)
  return (similarity * 100).toFixed(1)
}

export function formatUptime(seconds: number): string {
  if (seconds < 60) return `${seconds}s`
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m`
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  return `${hours}h ${minutes}m`
}
